export default __webpack_public_path__ + "static/media/988EAED9-9C28-484C-93D7-EA5CD9D5771F_1_105_c.2ae9f6d0.jpeg";